<template>
  <svg xmlns="http://www.w3.org/2000/svg" :width="width" :height="height" viewBox="0 0 20 20" fill="none">
    <path d="M9.00006 3.75H5.25006C4.42163 3.75 3.75006 4.42157 3.75006 5.24999L3.75001 14.7501C3.75 15.5786 4.42158 16.2501 5.25001 16.2501H14.7499C15.5784 16.2501 16.2499 15.5786 16.2499 14.7502L16.25 11.0001" 
    stroke="currentColor" stroke-width="1.5" stroke-linecap="round"/>
    <path d="M7 13V10.7501M10.0001 13V9M13 13V11.2501" stroke="currentColor" stroke-width="1.5" stroke-linecap="round"/>
    <path d="M14.5 8.77347V7.88524M14.5 3V3.88823M12.7693 6.88599L12 7.3301M16.2308 4.88748L17 4.44337M12.7693 4.88748L12 4.44337M16.2308 6.88599L17 7.3301M16.2765 5.88673C16.2765 5.56306 16.1899 5.25965 16.0388 4.99833C15.7315 4.46744 15.1575 4.11028 14.5 4.11028C13.8425 4.11028 13.2685 4.46744 12.9613 4.99842C12.8102 5.25973 12.7235 5.56315 12.7235 5.88673C12.7235 6.2104 12.8102 6.51382 12.9613 6.77514C13.2685 7.30603 13.8425 7.66318 14.5 7.66318C15.1575 7.66318 15.7315 7.30603 16.0388 6.77514C16.1899 6.51382 16.2765 6.2104 16.2765 5.88673Z" 
    stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
  </svg>
</template>

<script>
export default {
  name: 'AdAccountIcon',
  props: {
    width: {
      type: Number,
      default: 20
    },
    height: {
      type: Number,
      default: 20
    }
  }
}
</script>

<style scoped></style>